<template>
  <div>
    <Nav></Nav>

    <mdb-container class="page-title pt-4">
      <mdb-row class="mb-4">
        <mdb-col class="text-left">
          <h1>10 Critical Sales Skills</h1>
          <p>Identify and close your gaps</p>
        </mdb-col>
      </mdb-row>
    </mdb-container>

    <mdb-container class="skills-section results mt-2">
      <mdb-row class="d-flex">
        <mdb-col xl="4" md="4" class="tile-score d-flex" style="flex: 1">
          <mdb-card class="shd" style="flex: 1">
            <mdb-card-body>
              <h4
                class="mb-4"
                :title="overallScore/datacollection.datasets[0].data.length"
              >Your score</h4>
              <div class="flex-center flex-column">
                <div class="flex-center flex-column">
                  <mdb-icon v-if="overallScore/4<0.5" icon="award" class="award text-bronze" />
                  <mdb-icon
                    v-if="
                    overallScore/4>=0.5
                    &&
                    overallScore/4<0.75"
                    icon="award"
                    class="award text-silver"
                  />
                  <mdb-icon v-if="overallScore/4>=0.75" icon="award" class="award text-gold" />
                  <h6 class="mb-4 mt-3 uppercase">
                    <strong v-if="overallScore/4<0.5" class>BRONZE</strong>
                    <strong
                      v-if="
                    overallScore/4>=0.5
                    &&
                    overallScore/4<0.75"
                      class
                    >SILVER</strong>
                    <strong v-if="overallScore/4>=0.75" class>GOLD</strong>
                  </h6>
                  <div class="text-silver">
                    <div class="big-number text-silver">
                      <mdb-icon v-if="overallScore/4>=0.1" icon="star" />
                      <mdb-icon v-if="overallScore/4>=0.5" icon="star" />
                      <mdb-icon
                        v-if="
                      overallScore/4>=0.75
                      &&
                      overallScore/4<0.92
                      "
                        icon="star-half-alt"
                      />
                      <mdb-icon v-if="overallScore/4>=0.92" icon="star" />
                    </div>
                    <br />
                  </div>
                </div>
              </div>
            </mdb-card-body>
            <mdb-card-footer small muted>
              Last assessment: {{lastAssessmentDate | datetimemomentLLL}}
              <span class="date">
                <!-- causes error -->
                <!-- <router-link to="/course">Retake</router-link> -->
              </span>
            </mdb-card-footer>
          </mdb-card>
        </mdb-col>
        <mdb-col lg="8" md="8" class="tile-chart" style="flex: 1;">
          <mdb-card class="shd">
            <mdb-card-body>
              <h4 class="mb-4">Your skills</h4>
              <div>
                {{simplereactivity}}
                <radar-chart
                  id="radarchart1"
                  :chart-data="datacollection"
                  :padding="50"
                  :options="options"
                ></radar-chart>
              </div>
            </mdb-card-body>
            <mdb-card-footer>
              <ul class="main-gaps mb-0">
                <li class="uppercase">Your main gaps:</li>
                <li
                  v-for="(item,index) in this.yourMainGapsArrOfStrings"
                  class="text-red"
                  :key="'gap'+index"
                >{{yourMainGapsArrOfStrings[index]}}</li>
              </ul>
              <ul class="main-strengths mb-0">
                <li class="uppercase">Your core strenghts:</li>
                <li
                  v-for="(item,index) in this.yourMainGapsArrOfStrings"
                  class="text-green"
                  :key="'strength'+index"
                >{{yourMainStrengthsArrOfStrings[index]}}</li>
              </ul>
            </mdb-card-footer>
          </mdb-card>
        </mdb-col>
        <mdb-col xl="12" md="12" class="flex-center"></mdb-col>
      </mdb-row>
    </mdb-container>

    <mdb-container class="skills-section learning-path my-4 mt-5">
      <mdb-row class="mb-4">
        <mdb-col class="text-left">
          <h2 class="h2-section">Your Learning path</h2>
        </mdb-col>
      </mdb-row>
      <mdb-row class="mb-4">
        <mdb-col
          md="12"
          lg="12"
          xl="12"
          class="mb-4 d-flex"
          v-for="mc in datacollection.minicourses"
          :key="mc.mcname"
        >
          <router-link :to="getCourseUrlByMcName(mc.mcname)" class="bg w-100">
            <mdb-card class="box-gradient-white-2" :class="getTabColorByScore(mc.mcyourscore)">
              <!--<mdb-card-image :src="getPhotoUrlByMcName(mc.mcname)" alt="Card image cap"></mdb-card-image>-->
              <mdb-card-body>
                <div class="video-course text-middleGrey uppercase">
                  <mdb-icon icon="video" />
                  <span>&nbsp;Course</span>
                </div>
                <div class="offset-left">
                  <p
                    class="text-middleGrey"
                  >{{mthGetNumberOfLessonsByCoursename(mc.mcname)}} lessons</p>
                  <mdb-card-title class>{{mc.mcname}}</mdb-card-title>
                  <ScoreToGapVisualizer :score="mc.mcyourscore"></ScoreToGapVisualizer>
                  <!-- <mdb-badge pill :color="getColorByScore(mc.mcyourscore)" class="score">
                    <strong>{{getGradeByScore(mc.mcyourscore)}}</strong>
                  </mdb-badge>-->

                  <mdb-card-text>{{getTextByMcName(mc.mcname)}}</mdb-card-text>
                </div>
              </mdb-card-body>
              <mdb-card-footer small muted class="pt-2">
                <div class="offset-left">
                  <span class="text-grey">
                    <mdb-progress :height="5" :value="mthGetProgress(mc.mcname)" class="mt-2 mr-2" />
                    {{mthGetProgress(mc.mcname)}}%
                  </span>
                  <span class="learn">
                    {{mthWordStartOrContinueByProgress(mc.mcname)}} learning
                    <mdb-icon icon="angle-double-right" />
                  </span>
                </div>
              </mdb-card-footer>
            </mdb-card>
          </router-link>
        </mdb-col>

        <!-- <mdb-col col="3">
          <mdb-card>
            <mdb-card-image
              src="https://images.unsplash.com/photo-1494869042583-f6c911f04b4c?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2550&q=80"
              alt="Card image cap"
            ></mdb-card-image>
            <mdb-badge pill color="red" class="cat-badge">
              YOUR SCORE:
              <strong>2/5</strong>
            </mdb-badge>
            <mdb-card-body>
              <mdb-card-title>Emotional intelligence</mdb-card-title>
              <mdb-card-text>Emotional intelligence or EI is the ability to understand and manage your own emotions, and those of the people around you. People with a high degree of emotional intelligence know what they're feeling, what their emotions mean, and how these emotions can affect other people.</mdb-card-text>
            </mdb-card-body>
            <mdb-card-footer small muted>
              3 videos/8 min
              <span class="date">
                <mdb-btn color="primary" class="float-right" rounded>Start Learning</mdb-btn>
              </span>
            </mdb-card-footer>
          </mdb-card>
        </mdb-col>

        <mdb-col col="3">
          <mdb-card>
            <mdb-card-image
              src="https://images.unsplash.com/photo-1523390218733-2e5b84cd6974?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2700&q=80"
              alt="Card image cap"
            ></mdb-card-image>
            <mdb-badge pill color="red" class="cat-badge">YOUR SCORE: 2.4/5</mdb-badge>
            <mdb-card-body>
              <mdb-card-title>Time and priority management</mdb-card-title>
              <mdb-card-text>The highest achievers manage their time exceptionally well. By using the time-management techniques in this section, you can improve your ability to function more effectively – even when time is tight and pressures are high.</mdb-card-text>
            </mdb-card-body>
            <mdb-card-footer small muted>
              in ATTRACT
              <span class="date">21.07.2019</span>
            </mdb-card-footer>
          </mdb-card>
        </mdb-col>
        <mdb-col col="3">
          <mdb-card>
            <mdb-card-image
              src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2702&q=80"
              alt="Card image cap"
            ></mdb-card-image>
            <mdb-badge pill color="orange" class="cat-badge">YOUR SCORE: 4/5</mdb-badge>
            <mdb-card-body>
              <mdb-card-title>Influencing</mdb-card-title>
              <mdb-card-text>Influencing skills IS about behaving in ways that offers others the invitation to change (their behaviour, attitudes, thoughts, and ways) and/or accommodate your own wishes whilst accepting that they may be unable to or unwilling to, or are unprepared to meet our request to be influenced.</mdb-card-text>
            </mdb-card-body>
            <mdb-card-footer small muted>
              in ATTRACT
              <span class="date">21.07.2019</span>
            </mdb-card-footer>
          </mdb-card>
        </mdb-col>
        <mdb-col col="3">
          <mdb-card>
            <mdb-card-image
              src="https://images.pexels.com/photos/1120344/pexels-photo-1120344.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
              alt="Card image cap"
            ></mdb-card-image>
            <mdb-badge pill color="orange" class="cat-badge">YOUR SCORE: 4/5</mdb-badge>
            <mdb-card-body>
              <mdb-card-title>Questioning</mdb-card-title>
              <mdb-card-text>Learning to ask powerful questions will help you augment your personal and business communication. The most effective powerful questions begin with “What” or “How”, are short and to the point. When questioning, be genuinely curious about the person you are speaking to.</mdb-card-text>
            </mdb-card-body>
            <mdb-card-footer small muted>
              in ATTRACT
              <span class="date">21.07.2019</span>
            </mdb-card-footer>
          </mdb-card>
        </mdb-col>-->
      </mdb-row>
    </mdb-container>

    <Footer></Footer>
  </div>
</template>

<script>
//import LineChart from '../LineChart.js'
import Vue from "vue";
import firebase from "firebase/app";
import { store } from "../store";
import RadarChart from "../RadarChart.js";
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import ScoreToGapVisualizer from "../components/ScoreToGapVisualizer";
import {
  mdbContainer,
  mdbRow,
  mdbCol,
  mdbCard,
  mdbCardImage,
  mdbCardBody,
  mdbCardTitle,
  mdbCardText,
  mdbCardFooter,
  mdbBtn,
  mdbBadge,
  mdbIcon,
  mdbProgress,
  animateOnScroll
} from "mdbvue";
import { isNumber } from "util";

Chart.defaults.global.defaultFontSize = 12;
Chart.defaults.global.animation.duration = 3000;

export default {
  name: "AnimationsPage",
  directives: {
    animateOnScroll
  },
  components: {
    RadarChart,
    Nav,
    Footer,
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbCard,
    mdbCardImage,
    mdbCardBody,
    mdbCardTitle,
    mdbCardText,
    mdbCardFooter,
    mdbBtn,
    mdbBadge,
    mdbIcon,
    mdbProgress,
    ScoreToGapVisualizer
  },
  data() {
    //datasection
    return {
      courses: [], //used for progress presenting
      progressTrackingOfMine: [], //used for progress presenting
      lastAssessmentDate: "",
      yourMainGapsArrOfStrings: [],
      yourMainStrengthsArrOfStrings: [],
      window: {
        width: 0,
        height: 0
      },
      simplereactivity: "",
      overallScore: 0.1,
      datacollection: {
        labels: [],
        datasets: [
          {
            label: "",
            borderWidth: "5",
            data: [],
            datacandidates: [] //setinterval animation start block
          }
        ],
        minicourses: []
      },
      options: {
        scale: {
          pointLabels: {
            fontSize: 14,
            fontFamily: "roboto",
            fontColor: "#7B8183",
            labelMaxWidth: 18,
            labelWrap: true
          }
        },
        responsive: false,
        maintainAspectRatio: false,
        responsive: true,
        responsiveAnimationDuration: 0,
        duration: 4000,
        beginAtZero: true,
        legend: {
          display: false,
          labels: {
            fontColor: "red",
            fontSize: 18
          }
        },

        elements: {
          line: {
            foreColor: "grey",
            backgroundColor: "yellow"
          },
          point: {
            radius: 3,
            pointStyle: "circle",
            borderColor: "#5542FB"
          }
        }
        // title: {
        //   display: true,
        //   text: "Custom Chart Title"
        // }
      }
    };
  },
  mounted() {
    this.fillDataFromFirestore();

    this.mthFillCourses();

    this.mthFillProgressTrackingOfMine();
  },
  updated() {
    //console.log("UPDATED fired...");
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();

    //console.log("has filled? ");
    //console.log(this.$store.getters.getUserhasfilledhisassessment);

    if (
      this.$store.getters.getUserhasfilledhisassessment === null ||
      this.$store.getters.getUserhasfilledhisassessment === undefined ||
      typeof this.$store.getters.getUserhasfilledhisassessment ===
        "undefined" ||
      this.$store.getters.getUserhasfilledhisassessment == false
    )
      this.$router.replace("/assessment-welcome");
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    mthWordStartOrContinueByProgress(coursename) {
      var toret = "Start";

      var progress = this.mthGetProgress(coursename);

      if (progress > 1) toret = "Continue";

      return toret;
    },
    mthGetNumberOfLessonsByCoursename(coursename) {
      var toret = 0;

      this.courses.forEach(c => {
        //console.log(c)

        //var counter = 0;

        if (
          c.firedata.name === coursename &&
          c.firedata.newOrEditedCourseDetails
        ) {
          //toret = c.firedata.newOrEditedCourseDetails.length;

          c.firedata.newOrEditedCourseDetails.forEach(element => {
            if (element.type == "video" || element.type == "text") {
              toret++;
            }
          });
        }
      });
      return toret;
    },
    mthGetProgress(coursename) {
      var toret = 0.001;

      var licznik = this.mthGetSumOfVideosProgressesByCoursname(coursename);
      var mianownik = this.mthGetCourseTotalMinutesByName(coursename);

      if (mianownik === 0) return 0;
      if (licznik < 5) return 0;

      //console.log("licznik: " + licznik);
      //console.log("mianownik: " + mianownik);

      toret = (licznik * 100) / mianownik;

      if (toret > 98) return 100;
      if (toret < 0) return 0;

      toret = Math.round(toret);

      return toret;
    },
    mthGetSumOfVideosProgressesByCoursname(coursename) {
      var toret = 0.00000001;

      this.progressTrackingOfMine.forEach(t => {
        //console.log(t.firedata);

        if (t && t.firedata && t.firedata.courseslug && t.firedata.event) {
          let cname = t.firedata.courseslug
            .replace("-", " ")
            .replace("-", " ")
            .replace("-", " ")
            .replace("-", " ")
            .replace("-", " ")
            .replace("-", " ")
            .replace("-", " ")
            .replace("-", " ")
            .replace("-", " ")
            .replace("-", " ");
          if (
            cname === coursename &&
            t &&
            t.firedata &&
            t.firedata.event &&
            t.firedata.event.seconds &&
            isNumber(t.firedata.event.seconds)
          )
            toret += t.firedata.event.seconds;
        }
      });

      return toret;
    },
    mthGetCourseTotalMinutesByName(coursename) {
      let totalminutes = 0; //to not divide by 0 ;)
      //console.log('arg is'+coursename)

      this.courses.forEach(c => {
        if (
          c.firedata.name === coursename &&
          c.firedata.newOrEditedCourseDetails
        ) {
          c.firedata.newOrEditedCourseDetails.forEach(d => {
            if (d.type && d.type === "video") {
              if (d && d.data && d.data.data && d.data.data.vimeoduration) {
                totalminutes += d.data.data.vimeoduration;
              }
            }
          });
        }
      });

      return totalminutes;
    },
    mthFillProgressTrackingOfMine() {
      var refProgressTracking = firebase
        .firestore()
        .collection("progressTracking")
        .where("userEmail", "==", this.$store.getters.getUser.email);

      refProgressTracking.onSnapshot(querySnapshot => {
        this.progressTrackingOfMine = [];
        querySnapshot.forEach(doc => {
          this.progressTrackingOfMine.push({
            firedata: doc.data()
          });
        });
        //console.log(this.progressTrackingOfMine);
      });

      return 0.001;
    },
    mthFillCourses() {
      var refcourses = firebase.firestore().collection("courses");

      refcourses.onSnapshot(querySnapshot => {
        this.courses = [];
        querySnapshot.forEach(doc => {
          this.courses.push({
            firedata: doc.data()
          });
        });
        //console.log(this.courses);
      });
    },
    mthFill3GapsAnd3StrengthsBySortedMinicourses() {
      var mc = this.datacollection.minicourses;

      for (var i = 0; i < mc.length; i++) {
        if (i <= 2) this.yourMainGapsArrOfStrings.push(mc[i].mcname);
        if (i >= mc.length - 3)
          this.yourMainStrengthsArrOfStrings.push(mc[i].mcname);
      }

      //console.log(this.yourMainStrengthsArrOfStrings)
    },
    datacandidates2dataAnimate0() {
      //console.log("datacandidates2dataAnimate0 called");
      //this.datacollection = {}
    },
    datacandidates2dataAnimate() {
      //var dataset = this.datacollection.datasets[0];

      for (
        var i = 0;
        i < this.datacollection.datasets[0].datacandidates.length;
        i++
      ) {
        //console.log("iterate....");

        this.simplereactivity =
          "simple reactivity works " + i.toString() + new Date().toString();

        if (
          this.datacollection.datasets[0].data[i] ==
          this.datacollection.datasets[0].datacandidates[i]
        ) {
          //nothing
          //console.log("doing nothing, data is ");
          //console.log(this.datacollection.datasets[0].data);
        } else {
          //rewrite only 1 and exit
          this.datacollection.datasets[0].data[
            i
          ] = this.datacollection.datasets[0].datacandidates[i];

          // Vue.set(
          //   this.datacollection.datasets[0].data,
          //   i,
          //   this.datacollection.datasets[0].datacandidates[i]
          // );

          /*           console.log(
            "doing sth and break, wrote to data: " +
              this.datacollection.datasets[0].datacandidates[i]
          ); */

          //this.$forceUpdate()

          break;
        }
      }
    },
    sortMinicourses() {
      //mcname, mcyourscore
      this.datacollection.minicourses.sort((a, b) =>
        a.mcyourscore > b.mcyourscore ? 1 : -1
      );
    },
    getColorByScore(score) {
      if (score <= 1) return "red";
      if (score <= 2) return "orange";
      if (score <= 3) return "bg-lightGreen";
      if (score <= 4) return "bg-green";
    },
    getTabColorByScore(score) {
      if (score <= 1) return "left-bar-red";
      if (score <= 2) return "left-bar-orange";
      if (score <= 3) return "left-bar-lightGreen";
      if (score <= 4) return "left-bar-green";
    },
    getGradeByScore(score) {
      if (score <= 1) return "Your main gap";
      if (score <= 2) return "Your gap";
      if (score <= 3) return "Your strength";
      if (score <= 4) return "Your main strength";
    },
    getPhotoUrlByMcName(name) {
      if (name == "Emotional Intelligence")
        return "https://appen.nazwa.pl/hardlight/projekty/ex2/intelligence.jpg";
      if (name == "Questioning")
        return "https://appen.nazwa.pl/hardlight/projekty/ex2/questioning.jpg";
      if (name == "Resilience")
        return "https://appen.nazwa.pl/hardlight/projekty/ex2/resilience.jpg";
      if (name == "Influencing")
        return "https://appen.nazwa.pl/hardlight/projekty/ex2/influencing1.jpg";
      if (name == "Time Management")
        return "https://appen.nazwa.pl/hardlight/projekty/ex2/time.jpg";
      if (name == "Listening")
        return "https://appen.nazwa.pl/hardlight/projekty/ex2/listening.jpg";
      if (name == "Storytelling")
        return "https://appen.nazwa.pl/hardlight/projekty/ex2/p-1.jpg";
      if (name == "Growth Mindset")
        return "https://appen.nazwa.pl/hardlight/projekty/ex2/growth.jpg";
      if (name == "Rapport Building")
        return "https://appen.nazwa.pl/hardlight/projekty/ex2/conversation.jpg";
      if (name == "Concise Communication")
        return "https://appen.nazwa.pl/hardlight/projekty/ex2/presentation.jpg";
    },
    getTextByMcName(name) {
      if (name == "Emotional Intelligence") return "";
      if (name == "Questioning") return "";
      if (name == "Resilience") return "";
      if (name == "Influencing") return "";
      if (name == "Time Management") return "";
      if (name == "Listening") return "";
      if (name == "Storytelling") return "";
      if (name == "Growth Mindset") return "";
      if (name == "Rapport Building") return "";
      if (name == "Concise Communication") return "";
    },
    getCourseUrlByMcName(name) {
      //console.log('name is '+name);

      return (
        "/course/" +
        name
          .replace(" ", "-")
          .replace(" ", "-")
          .replace(" ", "-")
          .replace(" ", "-")
          .replace(" ", "-")
          .replace(" ", "-")
          .replace(" ", "-")
          .replace(" ", "-")
          .replace(" ", "-")
          .replace(" ", "-")
          .replace(" ", "-")
          .replace(" ", "-")
      );
    },
    fillDataFromFirestore() {
      // console.log(
      //   "calling fillDataFromFirestore, store.getters.getAssessmentIdParam = "
      // );
      // console.log(this.$store.getters.getAssessmentIdParam);

      //let biggest = citiesRef.where('population', '>', 2500000).orderBy('population').limit(2);

      firebase
        .firestore()
        .collection("usersFilledAssessments")
        .where("user", "==", this.$store.getters.getUser.email)
        .orderBy("createdAt", "desc")
        .limit(1)
        //.doc(this.$router.currentRoute.params.filledassessmentidrouterparam)
        //.doc(this.$store.getters.getAssessmentIdParam)
        //.doc()
        .get()
        .then(result => {
          //console.log(result);
          //if (!result.exists) return;
          var data = {};
          result.forEach(doc => {
            //console.log(doc);
            data = doc.data();
            //console.log(data);
          });

          // console.log("data is: ");
          // console.log(data);

          var score = 0;
          if (data && data.assessmentscore) score = data.assessmentscore;

          this.overallScore = Number(parseFloat(score.toFixed(1)));
          this.lastAssessmentDate = data.createdAt;
          this.datacollection = {
            labels: [],
            datasets: [{}],
            options: [
              {
                defaultFontSize: 40,
                legend: {
                  display: true
                }
              }
            ]
          };

          // console.log('slides length is: '+result.data().slides.length);
          // console.log('slides object is: ');
          // console.log(result.data().slides[0].skillname);

          this.datacollection.labels = [];
          this.datacollection.minicourses = [];
          this.datacollection.datasets[0].data = [];
          this.datacollection.datasets[0].datacandidates = [];

          for (var i = 0; i < data.slides.length; i++) {
            //console.log(result.data().slides[i].skillname);
            this.datacollection.labels.push(
              data.slides[i].skillname.split(" ")
            );
            //this.datacollection.labels.push(['push','array','to','array'])
            this.datacollection.minicourses.push({
              mcname: data.slides[i].skillname,
              mcyourscore: data.pointsarr[i].points
            });
            this.datacollection.datasets[0].datacandidates.push(
              //or data.push if no animation
              data.pointsarr[i].points
            );
            this.datacollection.datasets[0].data.push(data.pointsarr[i].points);
          }

          this.sortMinicourses(); //by rating ascending

          this.mthFill3GapsAnd3StrengthsBySortedMinicourses();

          this.datacollection.datasets[0].borderColor = "#5542FB";
          this.datacollection.datasets[0].backgroundColor = false;
          this.datacollection.datasets[0].borderWidth = "2";
          this.datacollection.datasets[0].pointBorderWidth = "4";

          //console.log(this.datacollection);
        });
    },
    getRandomInt() {
      return Math.floor(Math.random() * 5);
    },
    getRandomIntFromZeroToArgMinus1(max) {
      return Math.floor(Math.random() * Math.floor(max));
    },
    getRandomColor() {
      var letters = "0123456789ABCDEF";
      var color = "#";
      for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;

      if (window.innerWidth < 768) {
        //console.log("komora");
        this.options.scale.pointLabels.fontSize = 12;
      } else {
        //console.log("desktop");
        this.options.scale.pointLabels.fontSize = 16;
      }
    }
  }
};
</script>

<style>
</style>
